// extracted by mini-css-extract-plugin
module.exports = {"Admin":"Admin_Admin__IcQAn","SearchBar":"Admin_SearchBar__3VqBl"};